import React, { useState, useEffect, useContext } from "react";
import Button from "../../../components/_default/Button";
import DefineMedia from "../../../components/_default/DefineMedia";
import Input from "../../../components/_default/Input";
import Popup from "../../../components/_default/Popup";

import "./DefineWorkout.scss";
import Supersets from "../../../components/_workouts/Supersets";
import generateUnique from "../../../services/defaultFunctions/generateUnique";
import { getExercisesAurum, getExercisesCoach, getProgramsAurum, getProgramsCoach } from "../../../services/firebase/firestore/getData";
import { updateProgramWorkoutAurum, updateProgramWorkoutCoach, updateWorkoutAurum, updateWorkoutCoach } from "../../../services/firebase/firestore/updateData";
import { addProgramWorkoutAurum, addProgramWorkoutCoach, addWorkoutAurum, addWorkoutCoach } from "../../../services/firebase/firestore/saveData";
import { deleteMediaArrayFromStorage } from "../../../services/firebase/storage";
import isIterable from "../../../services/defaultFunctions/isIterable";
import UserContext from "../../../services/context/userContext";
import Header from "../../../components/_default/Header";
import Textarea from "../../../components/_default/Textarea";

function DefineWorkout({ ...props }) {
  const categories = ["All", "Upper", "Lower", "Core", "Cardio", "Plyometrics", "Mobility", "Corrective Exercise"];
  const [category, setCategory] = useState(categories[0]);
  const [image, setImage] = useState(false);
  const [exercises, setExercises] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [deleteUrlArray, setDeleteUrlArray] = useState(false);
  const [program,setProgram]=useState({})
  const [supersets, setSupersets] = useState([
    {
      exercises: [],
      id: "8796-8897a",
      name: "",
      rest_time_in_minutes: 0,
    },
  ]);

  const user = useContext(UserContext);
  const from = props?.location?.state?.from;
  // const isAdmin = ((from === "aurum" || from==="coach") && !user.admin && props?.location?.state?.update);
  // const isAdmin = (from  && (user.admin?user.admin:!user.admin) && (props?.location?.state?.update||props?.location?.state?.copy));
  const isAdmin = !(from === "coach" && !user.admin && props?.location?.state?.update); //first one same as main branc
  // const isAdmin = (from === "coach" && !user.admin && props?.location?.state?.update);
  // console.log("update state",(props.location.state.update),props.location.state.phase)
  const {programID,item}=props.location.state
  // console.log("from val in define_workout_page",from, programID,props.location.state)

  useEffect(()=>{
    if(from=="coach"){
      // console.log("coacooccoc")
    getProgramsCoach(user.id,(res)=>{
      // console.log("programs coach",res)
      let filterProgram=res.filter((program)=>program.id==programID)
      // console.log("filter program",filterProgram)
      setProgram(filterProgram[0])
    })
  }else{
    getProgramsAurum((res)=>{
      // console.log("aurum programs",res)
      let filterProgram=res.filter((program)=>program.id==programID)
      console.log("filter program",filterProgram)
      setProgram(filterProgram[0])
    })
  }
  },[])

  useEffect(() => {
    let _workout = props.location.state.item;
    if (props.location.state.update || props.location.state.copy) {
      // debugger
      //setCategory(_workout.category);
      setImage(_workout.image);
      setName(_workout.name);
      setDescription(_workout.description);
      setSupersets(_workout.supersets);
      setLoadingDuplicate(false);
      //window.scrollTo({top: 0, behavior: 'smooth'});
    }
    setUpdate(props.location.state.update);
    getExercisesAurum((aurum_result) => {
      getExercisesCoach(user.id, (coach_result) => {
        let _aurum_result = aurum_result
          ? aurum_result.map((aurum) => {
              return { ...aurum, from: "aurum" };
            })
          : [];
        let _coach_result = coach_result
          ? coach_result.map((coach) => {
              return { ...coach, from: user.id };
            })
          : [];
        let result = _aurum_result.concat(_coach_result);
        setExercises(result);
      }, category);
    }, category);
  }, [props.location.state, category]);

  // console.log("exercis")
  const addToDeleteUrl = (pageType, url) => {
    let _deleteUrlArray = isIterable(deleteUrlArray) ? [...deleteUrlArray] : [];
    _deleteUrlArray.push(url);
    setDeleteUrlArray(_deleteUrlArray);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const reorderChild = (list, start, end) => {
    const result = Array.from(list);
    const parent_start_index = result.findIndex((e) => e.id === start.droppableId);
    const parent_end_index = result.findIndex((e) => e.id === end.droppableId);
    const [removed] = result[parent_start_index].exercises.splice(start.index, 1);
    result[parent_end_index].exercises.splice(end.index, 0, removed);

    return result;
  };

  function onDragEnd(result) {
    const { destination, source, type, draggableId } = result;
    let new_supersets = supersets;

    if (!result.destination) {
      return;
    }
    switch (type) {
      case "parent":
        new_supersets = reorder(supersets, source.index, destination.index);
        break;
      case "child":
        new_supersets = reorderChild(supersets, source, destination);
        break;
      default:
        break;
    }
    setSupersets(new_supersets);
  }

  function addSet() {
    let _supersets = [...supersets];
    _supersets.push({
      exercises: [],
      id: generateUnique(1, 9),
      name: "",
      rest_time_in_minutes: 0,
      load:0,
    });
    setSupersets(_supersets);
  }

  function removeSet(set_idx) {
    let _supersets = [...supersets];
    switch (showPopup.type) {
      case "set":
        _supersets.splice(set_idx, 1);
        break;
      case "exercise":
        _supersets[showPopup.set_idx].exercises.splice(showPopup.exercise_idx, 1);
        break;

      default:
        break;
    }

    setSupersets(_supersets);
    setShowPopup(false);
  }

  function onClickSearch(e, set_idx) {
    console.log(e, set_idx);
    let _supersets = [...supersets];
    let _exercise = { ...e };

    _exercise.exercise_id = generateUnique(1, 9);

    if (!_supersets[set_idx].exercises) {
      _supersets[set_idx].exercises = [];
    }

    let subs = [];

    for (let i = 0; i < _supersets[set_idx]?.exercises[0]?.sets - 1; i++) {
      subs.push(_exercise);
    }

    let new_exercises = {
      exercise_id: generateUnique(1, 9),
      down_pause: 0,
      down: 0,
      sets: 1,
      up_pause: 0,
      name: _exercise.name,
      id: _exercise.id,
      starts_with: _exercise.starts_with,
      from: _exercise.from,
      subsitute: [],
      image: _exercise.image,
      reps: 0,
      up: 0,
      rest_time_in_minutes: 0,
      maxReps: 0,
      category: _exercise.category,
      speed: 0,
      heart: 0,
      notes: "",
      hold: 0,
      switch_sides: false,
      subexercises: subs

    };
     

    _supersets[set_idx].exercises.push(new_exercises);

    setSupersets(_supersets);
  }

  function onChange(e, type, exercise_idx, set_idx, subIdx, subItem) {
    let _supersets = [...supersets];

    if(subItem === true && _supersets[set_idx]?.exercises[exercise_idx]?.subexercises[subIdx] ) {
      _supersets[set_idx].exercises[exercise_idx].subexercises[subIdx][type] = e;
      // console.log(`change set: ${set_idx + 1} exercise: ${exercise_idx + 1} subexercise: ${subIdx + 1} change value: ${type}`);
    } else {

      switch (type) {
        case "addSubexercise":
          _supersets[set_idx].exercises[exercise_idx].subexercises.push(e);
          break;
        case "removeSubexercise":
          _supersets[set_idx].exercises[exercise_idx].subexercises.splice(e, 1);
          break;
        case "subsitute_add":
          _supersets[set_idx].exercises[exercise_idx].subsitute.push({ name: e.name, id: e.id, from: e.from, starts_with: e.starts_with });
          break;
        case "subsitute_remove":
          _supersets[set_idx].exercises[exercise_idx].subsitute.splice(e, 1);
          break;

        default:
          if (exercise_idx !== false && _supersets[set_idx]?.exercises[exercise_idx]) {
            _supersets[set_idx].exercises[exercise_idx][type] = e;
          } else {
            _supersets[set_idx][type] = e;
          }
          break;
      }
    }
    setSupersets(_supersets);
  }

  function initiateLoading(type, value) {
    if (type === "duplicate") {
      setLoadingDuplicate(value);
    } else {
      setLoading(value);
    }
  }
  // console.log("props.location.state.phase",props.location)

  function onSubmit(duplicate) {
    let _empty_exercises_in_superset = supersets.findIndex((e) => e.exercises.length <= 0);
    initiateLoading(duplicate ? "duplicate" : "save", true);
    if (name === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "name", message: "Add a name for your workout." });
    } else if (description === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "description", message: "Add a short description for your exercise." });
    } else if (_empty_exercises_in_superset >= 0) {
      initiateLoading(duplicate ? "duplicate" : "save", false); 
      setError({ type: "set_exercises", message: "Add at least one exercise.", idx: _empty_exercises_in_superset });
    } else {
      setError(false);
      console.log(props.location.state.phase);
      const _workout = props.location.state.phase ? ({
        category: category,
        name: name,
        description: description,
        image: image,
        supersets: supersets,
        phase: props.location.state.phase
      }):({
        category: category,
        name: name,
        description: description,
        image: image,
        supersets: supersets,
      });
      if(from==="coach"||!user.admin){
        if (props.location.state?.phase||props.location.state.item?.phase){
          if (update) {
            // debugger
            _workout.last_updated = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              // console.log("props.location.state.programID",props.location.state.programID)
              // updateProgramWorkoutCoach(user.id, _workout, props.location.state.programID, props.location.state.item.id,  (result) => {
              updateProgramWorkoutCoach(user.id, _workout, props.location.state.programID, props.location.state.item.id,  (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          } else {
            _workout.created = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              addProgramWorkoutCoach(user.id, _workout, props.location.state.programID, (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          }
        }else{
          if (update) {
            _workout.last_updated = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              // debugger
              // console.log("UUUUUUUUUUUUUU")
              updateWorkoutCoach(user.id, _workout, props.location.state.item.id, (result) => {
              // console.log("coach id ",user.id)
                saveCallback(result, duplicate, _workout)
              });
            });
          } else {
            // debugger
            _workout.created = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              addWorkoutCoach(user.id, _workout, (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          }
        }
      } else {
        if (props.location.state?.phase||props.location.state.item?.phase){
          if (update) {
            debugger
            _workout.last_updated = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              updateProgramWorkoutAurum(_workout, props.location.state.programID, props.location.state.item.id, (result) => {
                // console.log("upd workout ",result)
                saveCallback(result, duplicate, _workout)
              });
            });
          } else {
            _workout.created = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              addProgramWorkoutAurum(props.location.state.programID, _workout, (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          }
        }else{
          if (update) {
            debugger
            _workout.last_updated = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {

              updateWorkoutAurum(_workout, props.location.state.item.id, (result) => {
                // console.log("upd workout aurum",result)
                saveCallback(result, duplicate, _workout)
              });
            });
          }
          else if(props.location.state.copy){
            debugger
            // console.log("add workout to coach",props.location.state.copy)
            _workout.created = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              addWorkoutCoach(user.id, _workout, (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          } 
          else {
            _workout.created = new Date();
            deleteMediaArrayFromStorage(deleteUrlArray, () => {
              addWorkoutAurum(_workout, (result) => {
                saveCallback(result, duplicate, _workout)
              });
            });
          }
        }
        }
        
    }
  }

  function saveCallback(result, duplicate, _workout){
    // console.log("hitting that sec")
    if (result) {  
      if (duplicate) {
        debugger
        _workout.image = "";
        props.history.push("/workout", { update: false, copy: true, from: from, item: _workout });
      } else {
        if(props.location.state.phase){
          debugger
          // props.history.push("/programs");
          props.history.push("/program",{ update: true, from: from,program});
          window.location.reload(false);
        } else {
          debugger
          if(props.location.state.programID){
            props.history.push("/program",{ update: true, from: from,program});

          }else{

            props.history.push("/workouts");
          }
        }
      }
    } else {
      debugger
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "default", message: "An unexpected error occurred while updating this workout." });
    }
  }
//copy to coach func
  function copyToCoach() {
    debugger
    const item = {
      category: category,
      name: name,
      description: description,
      image: "",
      supersets: supersets,
    };
    props.history.push("/workout", { update: false, copy: true, from: "coach", item });
  }
  // console.log("isAdmin",isAdmin,props.location.state)

  return (
    <>
      {exercises && (
        <div className="c-page-wrapper" style={{flexFlow: 'column'}}>
          <Header title={update ? "Update Workout" : "Add Workout"} subtitle={true}/>
          <div className="c-page-main c-define-page c-page-details">
            {(isAdmin?isAdmin:!isAdmin) ? <h1></h1> : <h1>Workout</h1>}

            <div className="c-add-workout-header">
              <div className="c-image">
                <h3 className="c-upload-banner">Banner</h3>
                <DefineMedia isAdmin={isAdmin} error={error && error.type === "image" ? error.message : false} errorStyles={{ width: "310px" }} media={image} pageType={"image"} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/workouts/`} onMediaChange={(e) => setImage(e)} addToDeleteUrl={addToDeleteUrl} />
                {(isAdmin?isAdmin:!isAdmin) && <p className="c-pixels">800 x 800 pixels</p>}
              </div>
              <div className="c-header-input">
                {(isAdmin?isAdmin:!isAdmin) ? (
                  <>
                    <Input placeholder="Full name of workout" label="Name" value={name} onChange={(e) => setName(e)} error={error && error.type === "name" ? error.message : false} />
                    <Textarea placeholder="Short description of the workout" title={"Description"} value={description} onChange={(e) => setDescription(e.target.value)} error={error && error.type === "description" ? error.message : false} />
                  </>
                ) : (
                  <div className="c-no-admin-workout-header">
                    <div className="c-no-admin-input-replace">
                      <span>Name</span>
                      <p>{name}</p>
                    </div>
                    <div className="c-no-admin-input-replace">
                      <span>Description</span>
                      <p>{description}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="c-select-collection c-category">
              <>
                <Input type="select" label="Search by category" value={category} options={categories} onChange={(e) => setCategory(e)} />
              </>
            </div>

            <Supersets isAdmin={(isAdmin?isAdmin:!isAdmin)} exercises={exercises} supersets={supersets} setSupersets={setSupersets} onDragEnd={onDragEnd} removeSet={(e) => setShowPopup({ type: "set", id: e })} removeExercise={(exercise_idx, set_idx) => setShowPopup({ type: "exercise", exercise_idx: exercise_idx, set_idx: set_idx })} onClickSearch={(e, set_idx) => onClickSearch(e, set_idx)} onChange={(e, type, exercise_idx, set_idx, subIdx, subex) => onChange(e, type, exercise_idx, set_idx, subIdx, subex)} error={error} />

            {(isAdmin?isAdmin:!isAdmin) && (
              <>
                <button className="c-add-content-btn" style={{backgroundColor: "#2F727C"}} onClick={() => addSet()}>
                  Add Series
                </button>
                <div className="c-button-collection" style={{alignItems: "center"}}>
                  <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(false)} loading={loading} />
                  {/* <Button text="Save and add another" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(true)} loading={loadingDuplicate} /> */}
                  <p className="c-cancel-button" onClick={() => window.history.back()}>Cancel</p>
                </div>
              </>
            )}
            {/* commented code for copy btn  */}
            {/* {(from === "aurum"||from==="coach") && !user.admin && props.location.state.copy && (
              <div className="c-copy-workout-btn">
                <Button text="Copy workout" color="#fff" backgroundColor="#00BDA5" onSubmit={() => copyToCoach()} loading={loading} />
              </div>
            )} */}
          </div>
        </div>
      )}

      {showPopup && (
        <Popup
          title={"Remove set"}
          button="Remove"
          deletePopup={true}
          description={"Are you sure you want to remove this set? This can not be undone."}
          onAction={() => removeSet(showPopup.id)}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </>
  );
}

export default DefineWorkout;
